const BUSINESS_TZ = 'Asia/Ulaanbaatar'

/** The business-timezone (Asia/Ulaanbaatar) ISO date of an instant, the clock `business_today()` uses server-side. `''` for a missing or unparseable instant. */
export function businessDateIso(at: Date | string | null | undefined): string {
  if (at == null) return ''
  const instant = typeof at === 'string' ? new Date(at) : at
  if (Number.isNaN(instant.getTime())) return ''
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: BUSINESS_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(instant)
  const part = (type: string) => parts.find((p) => p.type === type)?.value ?? ''
  return `${part('year')}-${part('month')}-${part('day')}`
}

/** Today in Ulaanbaatar, the day every date decision uses; `now` is the browser's instant, whatever zone it is set to. */
export function businessTodayIso(now: Date = new Date()): string {
  return businessDateIso(now)
}

/** The Ulaanbaatar day of `now` as numbers, for code that needs a year, month or day rather than an ISO string. */
export function businessYmd(now: Date = new Date()): { year: number; month: number; day: number } {
  const [year, month, day] = businessTodayIso(now).split('-').map(Number)
  return { year, month, day }
}
